import axios from 'axios'

import {
  OWNER_REGISTER_REQUEST,
  OWNER_REGISTER_SUCCESS,
  OWNER_REGISTER_FAIL,
  OWNER_LOGIN_REQUEST,
  OWNER_LOGIN_SUCCESS,
  OWNER_LOGIN_FAIL,
  OWNER_LOGOUT,
  OWNER_DETAILS_FAIL,
  OWNER_DETAILS_REQUEST,
  OWNER_DETAILS_SUCCESS,
  OWNER_UPDATE_PROFILE_REQUEST,
  OWNER_UPDATE_PROFILE_SUCCESS,
  OWNER_UPDATE_PROFILE_FAIL
} from '../constants/ownerConstants.js'

import { API_URL } from '../apiUrl.js'

// Register owner
export const registerOwner = (ownerinfo) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: OWNER_REGISTER_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.post(
      `${API_URL}/owners/register`,
      ownerinfo,
      config
    )

    dispatch({ type: OWNER_REGISTER_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: OWNER_REGISTER_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

// Login owner
export const loginOwner = (email, password) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: OWNER_LOGIN_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.post(
      `${API_URL}/owners/auth`,
      { email, password },
      config
    )

    dispatch({ type: OWNER_LOGIN_SUCCESS, payload: data })

    localStorage.setItem('ownerInfo', JSON.stringify(data))
  } catch (err) {
    dispatch({
      type: OWNER_LOGIN_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}
// Logout owner
export const logoutOwner = (id) => async (dispatch) => {
  axios.defaults.withCredentials = true
  localStorage.removeItem('ownerInfo')

  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    axios.post(`${API_URL}/owners/logout`, { id }, config)

    dispatch({ type: OWNER_LOGOUT })
    document.location.href = '/'
  } catch (err) {
    dispatch({
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }

  try {
    await axios.post(`${API_URL}/owners/logout`)
  } catch (err) {
    console.error(err)
  }
}

// Get owner details
export const getOwnerDetails = (id) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: OWNER_DETAILS_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.get(`${API_URL}/owners/profile/${id}`, config)

    dispatch({
      type: OWNER_DETAILS_SUCCESS,
      payload: data
    })
  } catch (e) {
    dispatch({
      type: OWNER_DETAILS_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

// Update owner profile
export const updateOwnerProfile = (owner) => async (dispatch, getState) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: OWNER_UPDATE_PROFILE_REQUEST
    })

    const {
      ownerLogin: { ownerInfo }
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ownerInfo.token}`
      }
    }

    const { data } = await axios.put(
      `${API_URL}/owners/updprofile`,
      owner,
      config
    )

    dispatch({
      type: OWNER_UPDATE_PROFILE_SUCCESS,
      payload: data
    })
  } catch (e) {
    dispatch({
      type: OWNER_UPDATE_PROFILE_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}
